module.exports = __webpack_public_path__ + "media/images/balance-product-companies-4ab89e1c9e5dd5f15fe6e0d92262a3ac.png";